import React from "react";
import { Row, Col, Spinner } from "react-bootstrap";
import UseAdminAddBrand from "../../CustomHooks/Admin/UseAdminAddBrand";
import { ToastContainer } from "react-toastify";

const AdminAddBrandComp = () => {

  const [ValidateBrandName, ValidateBrandImage, isFormValid, isPress, loading, AddBrandName, OnChangeBrandImage, submitForm, BrandImage, BrandName] = UseAdminAddBrand()

  return (
    <div>
      <Row className="justify-content-start m-3  mt-5 ">
        <h3 className='fw-bold'>Add New Brand</h3>
        <Col sm="8">
          <div>
            <label htmlFor="upload-photo">
              <img
                src={BrandImage}
                alt="fzx"
                height="120px"
                width="120px"
                className="pointer-cursor mt-3"
              />
            </label>
            <input
              type="file"
              name="photo"
              id="upload-photo"
              onChange={OnChangeBrandImage}
              accept=".png, .jpg, .jpeg"
              onBlur={ValidateBrandImage}
            />
          </div>
          <input
            type="text"
            className="d-block mt-4 px-3 form-control h-60"
            placeholder="Brand Name"
            onChange={AddBrandName}
            value={BrandName}
            onBlur={ValidateBrandName}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="8" className="d-flex justify-content-end ">
          <button className="action-button d-inline mt-2  btn text-white dark-bg mb-5" onClick={submitForm} disabled={!isFormValid}>
            {isPress ? loading ? (<Spinner animation="border" variant="light" />) : (<span>Save</span>) : <span>Save</span>}
          </button>
        </Col>
      </Row>
      <ToastContainer />
    </div>
  );
};

export default AdminAddBrandComp;
